<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="">Inicio</a></li>
                <li><a routerLink="/categorias">Configuración Categorías</a></li>
                <li>Nueva Categoría</li>
            </ul>
            <h2>Nueva Categoría</h2>
        </div>
    </div>
    <div class="shape9"><img src="assets/img/shape8.svg" alt="image"></div>
</div>

<div class="andorra-apply-content ptb-70 animate__animated animate__fadeIn">
    <div class="container">
        <div class="row mx-auto">
            <div class="col-lg-2 col-md-12"></div>
            <div class="col-lg-8 col-md-12">
                <div class="apply-form">
                    <form [formGroup]="form" (ngSubmit)="post()">

                        <div class="form-group">
                            <mat-form-field class="example-full-width" appearance="fill" [style.width.%]="100">
                                <mat-label>Denominación</mat-label>
                                <textarea 
                                    formControlName="denominacion" 
                                    matInput 
                                    placeholder="Ingrese una denominación" 
                                    [class.is-invalid]="form.get('denominacion').invalid && form.get('denominacion').touched">
                                </textarea>
                                <small *ngIf="form.get('denominacion').invalid && form.get('denominacion').touched" class="text-danger">
                                    La denominación es obligatoria.
                                </small>
                            </mat-form-field>
                        </div>

                        <div class="form-group">
                            <label>Seleccione el tamaño del botón:</label>
                            <div class="botones-tamanos">
                                <!-- Botón 3 (Cuadrado) -->
                                <button 
                                    type="button" 
                                    class="btn-tamano" 
                                    [class.active]="form.get('size').value === 3"
                                    (click)="form.get('size').setValue(3)">
                                    <div class="boton-ejemplo tamano-3"></div>
                                    <span>Cuadrado</span>
                                </button>
                        
                                <!-- Botón 6 (Rectangular) -->
                                <button 
                                    type="button" 
                                    class="btn-tamano" 
                                    [class.active]="form.get('size').value === 6"
                                    (click)="form.get('size').setValue(6)">
                                    <div class="boton-ejemplo tamano-6"></div>
                                    <span>Rectangular</span>
                                </button>
                        
                                <!-- Botón 12 (Full) -->
                                <button 
                                    type="button" 
                                    class="btn-tamano" 
                                    [class.active]="form.get('size').value === 12"
                                    (click)="form.get('size').setValue(12)">
                                    <div class="boton-ejemplo tamano-12"></div>
                                    <span>Full</span>
                                </button>
                            </div>
                            <small *ngIf="form.get('size').invalid && form.get('size').touched" class="text-danger">
                                Seleccione un tamaño válido.
                            </small>
                        </div>

                        <div class="form-group">
                            <label class="label-img">Seleccione una imagen para el botón:</label>
                            <input
                                [disabled]="condition"
                                class="file-input"
                                type="file"
                                formControlName="imagen"
                                #fileInput
                                accept="image/jpeg, image/jpg, image/png, image/heic, image/heif"
                                (change)="onChangeFile(fileInput.files[0], $event)"
                            />
                            <mat-divider></mat-divider>
                            <div class="material-ripple-container mat-elevation-z4 mt-5">
                                
                                <ng-container *ngIf="file; else elseTemplate">
                                    <img *ngIf="!esHeic" [src]="imageUrl" />
                                    <p *ngIf="esHeic" class="text-muted mb-0">El formato HEIC/HEIF no tiene vista previa disponible. La imagen se subirá igual.</p>
                                </ng-container>
                                
                                <ng-template #elseTemplate>
                                    <img *ngIf="categoria?.imagen" 
                                         [src]="categoria.imagen | safe" 
                                         class="rounded float-start" 
                                         [alt]="categoria.denominacion" 
                                         width="300px">
                                </ng-template>
                                
                            </div>
                        </div>

                        <div class="form-group">
                            <label>Vista previa del botón:</label>
                            <div class="preview-container">
                                <div class="boton-preview"
                                    [class.tamano-3]="form.get('size').value === 3"
                                    [class.tamano-6]="form.get('size').value === 6"
                                    [class.tamano-12]="form.get('size').value === 12">
                                    
                                    <!-- Contenedor de imagen con overlay -->
                                    <div class="imagen-overlay">
                                        <img [src]="imageUrl || (categoria?.imagen | mediaOfertaLaboral:1 | safe)" 
                                             alt="Preview" 
                                             *ngIf="imageUrl || categoria?.imagen">
                                        
                                        <!-- Overlay que cubre toda la imagen -->
                                        <div class="overlay-completo">
                                            <span class="texto-centrado">
                                                {{ form.get('denominacion').value || 'Denominación' }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="botones-imagen">
                            <button [disabled]="!form.valid || flagProcesando" type="submit" class="btn btn-primary">Guardar</button>
                            <a routerLink="/tramites-configuracion">
                            <button type="button" class="btn btn-secondary">Cancelar</button>
                            </a>
                        </div>
                        <br>
                        <br>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Feedback de guardado -->
<app-spinner
    [show]="flagProcesando"
    [text]="'Guardando...'"
    [type]="'fullscreen'"
    [color]="'#124e91'"
    [trackColor]="'#1c75bc'"
    [blurBackground]="true">
</app-spinner>
